


































import Vue from 'vue'

export default Vue.extend({
    name: 'EventURLDialog',
    props: ['eventName','eventId'],
    data: () => ({
      eventUrlDialog: false, 
      url:''
    }),
    mounted() {
      const props = this.$router.resolve({ 
        name: 'Inscription',
        query: { "id_event": this.eventId }
      });
      this.url = window.location.origin +'/' + props.href;
    },
    methods: {
     
      handleClick() {
        this.$emit('click');
      },
      close(reset: boolean) {
     
        this.eventUrlDialog = false;
        this.handleClick();
      }
    }
  })
